// extracted by mini-css-extract-plugin
export default {"container":"Cr-z","brandName":"Dr-z","productName":"Er-z","productNamePdpEnhancements":"Fr-z","breakLongProductName":"Gr-z"};